import { forwardRef } from "react";
import { MDSActionMenu } from "@/mds/components/menu/action-menu/action-menu";
import { MDSActionMenuItem } from "@/mds/components/menu/action-menu/action-menu-item";
import { MDSActionMenuProps } from "@/mds/components/menu/action-menu/action-menu.types";
import { MDSMenuItemHeader } from "@/mds/components/menu/menu-item-header/menu-item-header";
import { MDSMenuContentItemKind, MDSMenuContentList } from "@/mds/components/menu/menu.types";
import { MDSMenuItemDivider } from "@/mds/components/menu/menu-item-divider";

interface MDSActionMenuWithContentProps extends MDSActionMenuProps {
  contentList: MDSMenuContentList;
}

export const MDSActionMenuWithContent = forwardRef<HTMLDivElement, MDSActionMenuWithContentProps>(
  ({ contentList, ...props }, ref) => {
    return (
      <MDSActionMenu {...props} ref={ref}>
        {contentList.map(item => {
          if (item.kind === MDSMenuContentItemKind.Item) {
            return <MDSActionMenuItem key={item.id} {...item} />;
          }
          if (item.kind === MDSMenuContentItemKind.Header) {
            return <MDSMenuItemHeader key={item.id} {...item} />;
          }
          if (item.kind === MDSMenuContentItemKind.Divider) {
            return <MDSMenuItemDivider key={item.id} />;
          }
        })}
      </MDSActionMenu>
    );
  }
);

MDSActionMenuWithContent.displayName = "MDSActionMenuWithContent";
